module.exports = __webpack_public_path__ + "img/settings-pink.e3a654ae.svg";